import {
  type NodeIconOptions,
  type NodeTypeIcon,
  nodeIconDefaultOptions,
} from '../NodeTypeIcon';
import { createSquareNodeTypeIcon, wrapNodeIconInSvgTag } from '../common';
import { drawSquareBackground } from '../drawIconBackground';

const ICON_SIZE = 40;

function createAzureErcIcon(options: NodeIconOptions = {}): string {
  const opts = { ...nodeIconDefaultOptions, ...options };

  const icon = `
    ${drawSquareBackground(ICON_SIZE, opts.style)}
    <path d="M19.9451 14.3159L17.2777 12.7759L9.88883 25.5738L12.5562 27.1138L19.9451 14.3159Z" fill="white"/>
    <path d="M22.6256 13.0148L19.9582 14.5548L27.3471 27.3527L30.0145 25.8127L22.6256 13.0148Z" fill="white"/>
    <path d="M27.2178 30.4222V27.3422H12.44V30.4222H27.2178Z" fill="white"/>
    <path d="M20.1089 14.6333C22.1793 14.6333 23.8578 12.9548 23.8578 10.8844C23.8578 8.81393 22.1793 7.1355 20.1089 7.1355C18.0384 7.1355 16.36 8.81393 16.36 10.8844C16.36 12.9548 18.0384 14.6333 20.1089 14.6333Z" fill="white"/>
    <path d="M30.2511 32.8644C32.3216 32.8644 34 31.186 34 29.1155C34 27.045 32.3216 25.3666 30.2511 25.3666C28.1807 25.3666 26.5022 27.045 26.5022 29.1155C26.5022 31.186 28.1807 32.8644 30.2511 32.8644Z" fill="white"/>
    <path d="M9.74889 32.8644C11.8193 32.8644 13.4978 31.186 13.4978 29.1155C13.4978 27.045 11.8193 25.3666 9.74889 25.3666C7.67843 25.3666 6 27.045 6 29.1155C6 31.186 7.67843 32.8644 9.74889 32.8644Z" fill="white"/>
  `;

  return wrapNodeIconInSvgTag(icon, ICON_SIZE, ICON_SIZE, 'topLeft', opts);
}

export const azureErcIcon: NodeTypeIcon = createSquareNodeTypeIcon(
  ICON_SIZE,
  createAzureErcIcon,
);
